import { useEffect, useState } from 'react';

import style from './style.module.css';
import 'rc-slider/assets/index.css';
import './style.css';

import { Range } from 'rc-slider';
import Checkbox from '@components/Checkbox';
import { useDebounce } from "../../hooks/useDebounce";

const Calculator = ({ data, min, max, type, initialValues, onChangeInfo, error, setError }) => {
    const [sliderValue, setSliderValue] = useState(initialValues);
    const [inputFirstValue, setInputFirstValue] = useState(initialValues[0]);
    const [inputSecondValue, setInputSecondValue] = useState(initialValues[1]);
    const [price, setPrice] = useState(0);
    const [isLobbyBoost, setIsLobbyBoost] = useState(false);
    const [isExpressBoost, setIsExpressBoost] = useState(false);
    const [lvlFirst, setLvlFirst] = useState(1);
    const [lvlSecond, setLvlSecond] = useState(2);
    const [isCalibrate, setIsCalibrate] = useState(false);
    const [isPartyCalibrate, setIsPartyCalibrate] = useState(false);
    // Добавляем состояние для отслеживания последнего измененного поля
    const [lastChanged, setLastChanged] = useState(null);

    const LOBBY_PERCENT = 50;
    const EXPRESS_PERCENT = 50;

    const debouncedFirstValue = useDebounce(inputFirstValue, 300);
    const debouncedSecondValue = useDebounce(inputSecondValue, 300);

    useEffect(() => {
        if (inputFirstValue === '' || inputSecondValue === '') return;
        const first = Math.max(min, Math.min(max, Number(debouncedFirstValue)));
        const second = Math.max(min, Math.min(max, Number(debouncedSecondValue)));

        if (isNaN(first) || isNaN(second)) return;

        let newFirst = first;
        let newSecond = second;

        if(first >=second){
            if(lastChanged === 'second'){
                setError(`Значение должено быть больше ${first}`);
                return;
            }
            newSecond = Math.min(max, first + 150);
        }
        setError('');

        newFirst = Math.max(min, Math.min(newFirst, max));
        newSecond = Math.max(min, Math.min(newSecond, max));

        setSliderValue([newFirst, newSecond]);

        if (inputFirstValue !== newFirst) setInputFirstValue(newFirst);
        if (inputSecondValue !== newSecond) setInputSecondValue(newSecond);

        updateInfo([newFirst, newSecond]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedFirstValue, debouncedSecondValue, min, max]);


    function calc(minElo, maxElo) {
        let result = 0;
        const table = {
            [[3001, 3200]]: 12000 / 199, // 10 lvl
            [[2801, 3001]]: 10000 / 200, // 10 lvl
            [[2601, 2801]]: 8000 / 200, // 10 lvl
            [[2401, 2601]]: 6000 / 200, // 10 lvl
            [[2201, 2401]]: 4000 / 200, // 10 lvl
            [[2001, 2201]]: 3000 / 200, // 10 lvl
            [[1751, 2001]]: 2500 / 250, // 9 lvl
            [[1531, 1751]]: 1800 / 220, // 8 lvl
            [[1351, 1531]]: 1360 / 180, // 7 lvl
            [[1201, 1351]]: 1020 / 150, // 6 lvl
            [[1051, 1201]]: 780 / 150, // 5 lvl
            [[901, 1051]]: 780 / 150, // 4 lvl
            [[751, 901]]: 780 / 150, // 3 lvl
            [[501, 751]]: 1000 / 250, // 2 lvl
            [[0, 501]]: 2000 / 500, // 1 lvl
        };

        for (let i = minElo + 1; i <= maxElo; i++) {
            for (const [k, v] of Object.entries(table)) {
                const range = k.split`,`.map(Number);
                if (i >= range[0] && i <= range[1]) {
                    result += v;
                    break;
                }
            }
        }

        return Math.round(result);
    }

    const calculatePrice = (value, lobby = isLobbyBoost, express = isExpressBoost) => {
        let basePrice = 0;

        if (type === "mm") {
            for (let i = value[0] - 1; i < value[1] - 1; i++) {
                basePrice += data[i].price;
            }
        } else {
            for (let i = 0; i < data.length; i++) {
                if (data[i].elo < value[0]) setLvlFirst(i);
                if (data[i].elo < value[1]) setLvlSecond(i);
            }
            basePrice = calc(value[0], value[1]);
        }

        let total = basePrice;
        if (lobby) total += total * (LOBBY_PERCENT / 100);
        if (express) total += total * (EXPRESS_PERCENT / 100);

        return Math.round(total);
    };

    const updateInfo = (value) => {
        const price = calculatePrice(value);
        setPrice(price);
        onChangeInfo({
            from: type === 'mm' ? data[value[0] - 1].name : value[0],
            to: type === 'mm' ? data[value[1] - 1].name : value[1],
            price,
            lobby: isLobbyBoost,
            express: isExpressBoost,
        });
    };

    const onSliderChange = (value) => {
        let [first, second] = value;
        setSliderValue([first, second]);
        setInputFirstValue(first);
        setInputSecondValue(second);
        setLastChanged(null);
        updateInfo([first, second]);
    };


    const onFirstInputChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            const number = Number(value);
            setInputFirstValue(number);
            setLastChanged('first');
        }
    };

    const onSecondInputChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            const number = Number(value);
            setInputSecondValue(number);
            setLastChanged('second');
        }
    };

    const onFirstBlur = () => {
        if (inputFirstValue === '') {
            const fixed = min;
            setInputFirstValue(fixed);
            updateInfo([fixed, Number(inputSecondValue) || max]);
        }
    };

    const onSecondBlur = () => {
        if (inputSecondValue === '') {
            const fixed = max;
            setInputSecondValue(fixed);
            updateInfo([Number(inputFirstValue) || min, fixed]);
        }
    };

    const onLobbyBoost = () => setIsLobbyBoost(!isLobbyBoost);
    const onExpressBoost = () => setIsExpressBoost(!isExpressBoost);
    const onCalibrate = () => {
        setIsCalibrate(!isCalibrate);
        setIsPartyCalibrate(false);
    };
    const onPartyCalibrate = () => {
        setIsPartyCalibrate(!isPartyCalibrate);
        setIsCalibrate(false);
    };

    useEffect(() => {
        const price = calculatePrice(sliderValue);
        setPrice(price);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        updateInfo(sliderValue);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLobbyBoost, isExpressBoost]);

    return (
        <div>
            <div className={style.calculator__ranks}>
                {type === "mm" ? (
                    <>
                        <div className={style.calculator__col}>
                            <h4 className={style.calculator__ratingname}>Текущий рейтинг</h4>
                            <img className={style.calculator__image} src={data[sliderValue[0] - 1].src}
                                 alt={'MM level'}/>
                            <span className={style.calculator__rankname}>{data[sliderValue[0] - 1].name}</span>
                        </div>
                        <div className={style.calculator__col}>
                            <h4 className={style.calculator__ratingname}>Желаемый рейтинг</h4>
                            <img className={style.calculator__image} src={data[sliderValue[1] - 1].src} alt={'rating'}/>
                            <span className={style.calculator__rankname}>{data[sliderValue[1] - 1].name}</span>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={style.calculator__col_f}>
                            <img src={data[lvlFirst].src} className={style.calculator__image_lvl} alt={'level'}/>
                            <div className={style.calculator__counter}>
                                <h3>Текущий рейтинг</h3>
                                <input
                                    type='number'
                                    inputMode='numeric'
                                    pattern='\d*'
                                    className={style.calculator__count_input}
                                    value={inputFirstValue}
                                    onChange={onFirstInputChange}
                                    onBlur={onFirstBlur}
                                />
                            </div>
                        </div>
                        <div className={style.calculator__col_f}>
                            <img src={data[lvlSecond].src} className={style.calculator__image_lvl} alt={'level'}/>
                            <div className={style.calculator__counter}>
                                <h3>Желаемый рейтинг</h3>
                                <input
                                    type='number'
                                    inputMode='numeric'
                                    pattern='\d*'
                                    className={style.calculator__count_input}
                                    value={inputSecondValue}
                                    onChange={onSecondInputChange}
                                    onBlur={onSecondBlur}
                                />
                                {error && (
                                    <div className={style.error}>
                                        {error}
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className={style.calculator__range}>
                <Range
                    min={min}
                    max={max}
                    value={sliderValue}
                    onChange={onSliderChange}
                    allowCross={false}
                    pushable={1}
                />
            </div>
            <div className={style.calculator__discount_line}>
                <div className={style.calculator__checkbox}>
                    <Checkbox onCheckBoxClick={onLobbyBoost}/>
                    <span className={style.calculator__label}>Буст в лобби (+50%) (игра в пати)</span>
                </div>
                <div className={style.calculator__checkbox}>
                    <Checkbox onCheckBoxClick={onExpressBoost}/>
                    <span className={style.calculator__label}>Экспресс буст (+50%) (скорость х2)</span>
                </div>
                {type === "mm" && (
                    <>
                        <div className={style.calculator__checkbox}>
                            <Checkbox value={isCalibrate} onCheckBoxClick={onCalibrate}/>
                            <span className={style.calculator__label}>Калибровка аккаунта (+€25)</span>
                        </div>
                        <div className={style.calculator__checkbox}>
                            <Checkbox value={isPartyCalibrate} onCheckBoxClick={onPartyCalibrate}/>
                            <span className={style.calculator__label}>Калибровка аккаунта в пати (+€35)</span>
                        </div>
                    </>
                )}
            </div>
            <span className={style.calculator__price}>
                Итоговая цена: <span>{!error ? price : 0} РУБ</span>
            </span>
        </div>
    );
};

export default Calculator;
